module.exports = __webpack_public_path__ + "img/f.32bc1ec1.jpg";